import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  TextField,
  Snackbar
} from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  linkContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
  },
  linkText: {
    flex: 1,
    marginRight: theme.spacing(1),
  },
  expirationText: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
  }
}));

const ShareDialog = ({ open, onClose, shareLink, expirationDate }) => {
  const classes = useStyles();
  const [copySuccess, setCopySuccess] = useState(false);

  // Format expiration date
  const formattedDate = expirationDate 
    ? new Date(expirationDate).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    : '';

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareLink)
      .then(() => {
        setCopySuccess(true);
      })
      .catch((err) => {
        console.error('Could not copy text: ', err);
      });
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Share Search Results</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            A shareable link has been created for your current search results.
            Anyone with this link can view these freelancers without signing in.
          </Typography>
          <Box className={classes.linkContainer}>
            <TextField
              className={classes.linkText}
              value={shareLink}
              variant="outlined"
              size="small"
              fullWidth
              InputProps={{
                readOnly: true,
              }}
            />
            <IconButton onClick={handleCopyLink} color="primary">
              <FileCopyIcon />
            </IconButton>
          </Box>
          <Typography variant="body2" className={classes.expirationText}>
            This link will expire on {formattedDate} (14 days from now).
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar 
        open={copySuccess} 
        autoHideDuration={3000} 
        onClose={() => setCopySuccess(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setCopySuccess(false)} severity="success">
          Link copied to clipboard!
        </Alert>
      </Snackbar>
    </>
  );
};

export default ShareDialog;
